export default "__VITE_ASSET__C3l0BzL1__"